import React, { useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';

import WMICHOCustomCoverageTerm from '../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTerm';
import WMICHODesignatedPremisesLiabilityCovDetailView from './WMICHODesignatedPremisesLiabilityCovDetailView/WMICHODesignatedPremisesLiabilityCovDetailView';

import messages from './WMICHODesignatedPremisesLiabilityCov.messages';
import metadata from './WMICHODesignatedPremisesLiabilityCov.metadata.json5';

function WMICHODesignatedPremisesLiabilityCov(props) {
    const {
        id,
        dwellingVM,
        path,
        onUpdateJobAndCoverage,
        readOnly,
        onValidationChange: parentOnValidate,
        showErrors: parentShowErrors,
    } = props;
    const translator = useTranslator();

    const updateJobAndCoverage = async () => {
        await onUpdateJobAndCoverage(undefined, `${path}.terms[0].directValue`);
    };

    const minimumDesignatedPremisesLiabilityValidCheck = useCallback(
        () => dwellingVM?.designatedPremisesLiabilityCovItems?.value?.length > 0,
        [dwellingVM]
    );

    const overrideProps = {
        oneLocationRequiredMessage: {
            visible: !minimumDesignatedPremisesLiabilityValidCheck(),
        },
        designatedPremisesCoverageList: {
            id,
            addButtonLabel: messages.addLocationButton,
            coverageItemsVM: dwellingVM?.designatedPremisesLiabilityCovItems,
            detailViewComponent: WMICHODesignatedPremisesLiabilityCovDetailView,
            dtoType:
                // eslint-disable-next-line no-secrets/no-secrets
                'wmic.edge.ca.capabilities.policyjob.lob.homeownersHOE.coverables.dto.dwelling.DesignatedPremisesLiabilityCovItemDTO_Ext',
            dwellingVM,
            onComponentValidation: minimumDesignatedPremisesLiabilityValidCheck,
            onValidationChange: parentOnValidate,
            onUpdateJobAndCoverage: updateJobAndCoverage,
            readOnly,
            showErrors: parentShowErrors,
            VMData: [
                {
                    headerText: translator(messages.location),
                    path: 'location',
                },
            ],
        },
    };

    const resolvers = {
        resolveComponentMap: {
            WMICHOCustomCoverageTerm,
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={dwellingVM}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={parentOnValidate}
            showErrors={parentShowErrors}
        />
    );
}

export default WMICHODesignatedPremisesLiabilityCov;
